import styled from 'styled-components';

export const InactiveConnectionContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #1a1a1a;
  color: white;
`;

export const GuacamoleContainer = styled.div<{ isConnected: boolean }>`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  outline: none;

 
`;
